import { CHANGE_SUBJECT } from 'constants';
import { AUTHORITIES } from 'constants';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import  { useParams, useNavigate } from 'react-router-dom';
import { Cookies } from 'react-cookie';
  
export const RoleChange = () => {
    const {authorities, subject} = useParams();
    const forPersonOib = useSelector((state) => state.authentication.userData.userOib);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(()=>{
        const _authorities = authorities.split(",").map((authority) => {
            return { authority }
        });

        const _subject = subject.split(",").map((subjectAtribute) => subjectAtribute);
        const [forLegalIps, forLegalIzvor, toLegalIps, toLegalIzvor] = [..._subject];
       dispatch({
           type: AUTHORITIES,
           payload:_authorities
       });
       dispatch({
           type: CHANGE_SUBJECT,
           payload:{
            forLegalIps,
            forLegalIzvor,
            forPersonOib:"null",
            toLegalIps,
            toLegalIzvor,
           }
       })
       const cookie = new Cookies(document.cookie);
       const decoded = cookie.get("token");
       localStorage.setItem("token",decoded);
       navigate('/dash',{state: {redirect:true}});
    },[])
  return (
    <></>
  )
}